import BaseAPIRepository, { BaseAPIResponse } from 'api/base';
import { BASE_URL } from 'const';
import { FERequestErrorsHandler } from 'utils';
import { CreateSavedAddressRequest } from './CreateSavedAddressRequest';
import {
  GetSavedAddressesResponse,
  SavedAddressItem,
} from './GetSavedAddressesResponse';

export const savedAddressesApi = {
  getSavedAddresses: (signal?: AbortSignal) =>
    new Promise<GetSavedAddressesResponse>((resolve, reject) => {
      const url = `${BASE_URL}/api/v1/saved-addresses`;

      BaseAPIRepository.get<BaseAPIResponse<GetSavedAddressesResponse>>(url, {
        signal,
      }).then(
        (result) => resolve(result.data.result),
        (error) => FERequestErrorsHandler(error, reject),
      );
    }),

  createSavedAddress: (
    body: CreateSavedAddressRequest,
    signal?: AbortSignal,
  ) =>
    new Promise<SavedAddressItem>((resolve, reject) => {
      const url = `${BASE_URL}/api/v1/saved-addresses`;

      BaseAPIRepository.post<BaseAPIResponse<SavedAddressItem>>(url, body, {
        signal,
      }).then(
        (result) => resolve(result.data.result),
        (error) => FERequestErrorsHandler(error, reject),
      );
    }),

  deleteSavedAddress: (id: string, signal?: AbortSignal) =>
    new Promise<string>((resolve, reject) => {
      const url = `${BASE_URL}/api/v1/saved-addresses/${id}`;

      BaseAPIRepository.delete<BaseAPIResponse<string>>(url, {
        signal,
      }).then(
        (result) => resolve(result.data.result),
        (error) => FERequestErrorsHandler(error, reject),
      );
    }),
};
